export default __webpack_public_path__ + "static/media/relative-faux-book-pro.e792fe86.woff2";